import { Component, OnInit, Inject, Input } from '@angular/core';
import { environment } from 'src/environments/environment';
import { NgbCarouselConfig, NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap'
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { unsupported } from '@angular/compiler/src/render3/view/util';

@Component({
  selector: 'app-productimgpopup',
  templateUrl: './productimgpopup.component.html',
  styleUrls: ['./productimgpopup.component.scss']
})
export class ProductimgpopupComponent implements OnInit {
  @Input() iteamlist: IItem[];
  currentphoto:string;
  subscription:Subscription;
  vehiclePhotos: any[];
  vehicleimages: any[];  
  loginForm: FormGroup;
  show: boolean;
  _lightbox: any;
  constructor(config: NgbCarouselConfig ,public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ProductimgpopupComponent>,) {
		// customize default values of carousels used by this component tree
		config.interval = 10000;
		config.wrap = false;
		config.keyboard = false;
    config.pauseOnHover = false;
    this.triggerInterval();
    
	}

  ngOnInit(): void {
    this.openImage()
    this,this.currentphoto=this.iteamlist[0].fileUrl;
    
  }
  setIndex(item){
    const current=this.iteamlist.find(m =>m.fileUrl ===item.fileUrl);
    this.currentphoto=current.fileUrl;
      }
      gotoprev(){
        const current=this.iteamlist.find(m =>m.fileUrl === this.currentphoto);
        const index=this.iteamlist.indexOf(current);
        let nextIteam='';
        if(index !==0){
          nextIteam=this.iteamlist[index - 1].fileUrl
          this.currentphoto = nextIteam;
        }
      }
      gotonext(){
        const current=this.iteamlist.find(m =>m.fileUrl === this.currentphoto);
        const index=this.iteamlist.indexOf(current);
        let nextIteam='';
        if(index <this.iteamlist.length -1){
          nextIteam=this.iteamlist[index +1].fileUrl
          this.currentphoto = nextIteam;
        }else{
          this.subscription && this.subscription.unsubscribe();
          this.triggerInterval();
          this.currentphoto=this.iteamlist[0].fileUrl;
        }
      }
      checkedforLastImage(){
if(this.iteamlist !== null){
  const current=this.iteamlist.find(m =>m.fileUrl === this.currentphoto);
        const index=this.iteamlist.indexOf(current);
        if(index < this.iteamlist.length -1){
          return true;
          }else{
            return false;
          }
          }else{
            return true;
}
      }
      checkedforFirstImage(){
        if(this.iteamlist !== null){
          const current = this.iteamlist.find(m =>m.fileUrl === this.currentphoto);
                const index = this.iteamlist.indexOf(current);
                if(index === 0){
                  return false;
                  }else{
                    return true;
                  }
                  }else{
                    return false;
        }
              }
  triggerInterval(){

  }
 
  openImage(): void {
    this.vehiclePhotos = [];
    this.vehicleimages = [];    
    this.vehiclePhotos = this.data.image;


    this.vehiclePhotos.forEach(e => {
      this.vehicleimages.push(
        {
          src: environment.imageBaseUrl + 'DBT/ProductImage/' + e.imagePath,
          thumb: environment.imageBaseUrl + 'DBT/ProductImage/' + e.imagePath,
          
        });
    });
    // this._lightbox.open(this.vehicleimages, 0, { centerVertically: true ,
    // showImageNumberLabel:true, alwaysShowNavOnTouchDevices:true, wrapAround:true,});
  }
 
}
export interface IItem{
    fileId:number;
    fileUrl:string;
    fileTitle:string;
} 
